import {
  PhysicalKind,
  data_type_semantic,
  physical_kind_from_wire,
  semantic_type_display,
} from "target_wasm";

export const semanticLabel = (dataType: string) => {
  const kind = physical_kind_from_wire(dataType);
  return kind === PhysicalKind.ND
    ? dataType
    : semantic_type_display(data_type_semantic(kind));
};
